import { jsx as _jsx } from "react/jsx-runtime";
// Task M4: workspace-level paper visibility (master + per-chart override).
// Mirror WorkspaceLiveTradingContext nhưng gộp hook+context 1 file (state nhỏ).
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
const WorkspacePaperVisibilityContext = createContext(null);
/** Optional — single-chart (không provider) trả null, giữ hành vi legacy. */
export function useOptionalWorkspacePaperVisibility() {
    return useContext(WorkspacePaperVisibilityContext);
}
function storageKey(workspaceId) {
    return `vnsc_paper_visibility_${workspaceId ?? "default"}`;
}
function loadStored(workspaceId) {
    try {
        if (typeof window === "undefined" || !window.localStorage)
            return {};
        const raw = window.localStorage.getItem(storageKey(workspaceId));
        if (!raw)
            return {};
        const parsed = JSON.parse(raw);
        return {
            master: typeof parsed.master === "boolean" ? parsed.master : undefined,
            perChart: parsed.perChart && typeof parsed.perChart === "object" ? parsed.perChart : undefined,
        };
    }
    catch {
        return {};
    }
}
export function useWorkspacePaperVisibility(options) {
    const { workspaceId, charts } = options;
    const [master, setMasterState] = useState(() => loadStored(workspaceId).master ?? true);
    const [perChart, setPerChart] = useState(() => loadStored(workspaceId).perChart ?? {});
    useEffect(() => {
        try {
            if (typeof window !== "undefined" && window.localStorage) {
                window.localStorage.setItem(storageKey(workspaceId), JSON.stringify({ master, perChart }));
            }
        }
        catch {
            // Bỏ qua khi storage bị chặn.
        }
    }, [workspaceId, master, perChart]);
    const setMaster = useCallback((enabled) => setMasterState(enabled), []);
    const setChart = useCallback((chartId, enabled) => {
        setPerChart((prev) => (prev[chartId] === enabled ? prev : { ...prev, [chartId]: enabled }));
    }, []);
    const clearChart = useCallback((chartId) => {
        setPerChart((prev) => {
            if (!(chartId in prev))
                return prev;
            const next = { ...prev };
            delete next[chartId];
            return next;
        });
    }, []);
    return useMemo(() => ({ master, perChart, charts, setMaster, setChart, clearChart }), [master, perChart, charts, setMaster, setChart, clearChart]);
}
export function WorkspacePaperVisibilityProvider(props) {
    return (_jsx(WorkspacePaperVisibilityContext.Provider, { value: props.value, children: props.children }));
}
